import React from 'react'
import slider1 from '../Assets/Images/contactus.jpeg'
import { Container } from 'react-bootstrap'

import ContactForm from '../Components/ContactForm';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { grey} from '@mui/material/colors';
import { Helmet } from 'react-helmet-async';

const Contact = () => {
  return (
    <div >
      <Helmet>
        <title>Contact</title>
        <meta
          name="description"
          content="Please complete this form, and we'll respond to your inquiries promptly."
        />
        <link rel="canonical" href="https://oyoyolubricant.com/contact-us" />
      </Helmet>
      <div className="mb-5 h-96" >
        <div className="h-full w-full" style={{ backgroundImage: `url(${slider1})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
              <div className="lg:pl-14 h-full w-full  slide-content text-slate-100 bg-overlay">
                <div>
                  <div className="flex justify-center items-center flex-col w-full h-full px-2 py-5">
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <Container>
        
        <div className="grid grid-cols-1 gap-5 md:gap-3 pb-5 px-2 lg:grid-cols-2 mx-auto">
          <div>
          <div className='flex gap-3 items-start flex-col justify-start'>
           <div className="flex gap-3 items-start justify-start">
           <div className='w-16 h-16 bg-primary-300 rounded-sm flex justify-center items-center'><EmailIcon style={{color: grey[100]}} /></div>
            <div>
              <h3 className=' text-start font-bold text-lg text-textColor-100'>Send Email</h3>
              <p className='font-semibold text-sm text-start text-textColor-100'>customercare@oyoyolubricant.com</p>
              <p className='font-semibold text-sm text-start text-textColor-100'>sales@oyoyolubricant.com</p>
            </div>
           </div>
           <div className="flex gap-3 items-start justify-start">
           <div className='w-16 h-16 bg-primary-300 rounded-sm flex justify-center items-center'><PhoneIcon style={{color: grey[100]}} /></div>
            <div>
              <h3 className=' text-start font-bold text-lg text-textColor-100'>call</h3>
              <p className='font-semibold text-sm text-start text-textColor-100'>+2347045340159</p>
              
            </div>
           </div>
            
          </div>
          <ContactForm />
          </div>
          
          <div className=''>
          <div className='flex gap-3 items-start justify-start mb-12'>
            <div className='w-16 h-16 bg-primary-300 rounded-sm flex justify-center items-center'><LocationOnIcon style={{color: grey[100]}} /></div>
            <div>
              <h3 className='pb-2 text-start font-bold text-lg text-textColor-100'>Map</h3>
              <p className='font-semibold text-base text-start text-textColor-100'>Oraifite, Anambra State</p>
            </div>
          </div>
          <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.988150763321!2d6.835973474988536!3d5.996361993988721!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1043bd0026e19ce3%3A0xe36722b0f08f549f!2soyoyo%20lubricant%20company!5e0!3m2!1sen!2sch!4v1725463369517!5m2!1sen!2sch"
      width="600"
      height="300"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
          </div>
          
        </div>
      </Container>
      
    </div>
  )
}

export default Contact
